import React, { FunctionComponent } from 'react';
import { Form, Field } from 'react-final-form';
import i18next from 'i18next';

import {
  composeValidators,
  emailConfirmationValidation,
  emailValidation,
  passwordConfirmationValidation,
  passwordValidation,
  phoneNumberValidation,
  requiredValidation,
} from 'helpers/validations';

import Input from 'components/inputs/Input';

import { FormContent, FormButtonContainer, FormSubmitButton } from 'styles/form';

import { IRegisterFormProps } from './types';
import { PageLink } from './styles';
import './i18n';

const RegisterForm: FunctionComponent<IRegisterFormProps> = ({ onSubmit }) => (
  <Form
    onSubmit={onSubmit}
    render={({ handleSubmit, submitting, pristine }) => (
      <FormContent data-testid="register-form" onSubmit={handleSubmit}>
        <Field
          label={i18next.t<string>('REGISTER_FORM:FIRST_NAME')}
          name="firstName"
          render={Input}
          validate={requiredValidation}
        />
        <Field
          label={i18next.t<string>('REGISTER_FORM:LAST_NAME')}
          name="lastName"
          render={Input}
          validate={requiredValidation}
        />
        <Field
          label={i18next.t<string>('REGISTER_FORM:PHONE')}
          name="phone"
          render={Input}
          validate={composeValidators(requiredValidation, phoneNumberValidation)}
        />
        <Field
          label={i18next.t<string>('REGISTER_FORM:EMAIL')}
          name="email"
          render={Input}
          type="email"
          validate={composeValidators(requiredValidation, emailValidation)}
        />
        <Field
          label={i18next.t<string>('REGISTER_FORM:EMAIL_CONFIRMATION')}
          name="emailConfirmation"
          render={Input}
          type="email"
          validate={composeValidators(requiredValidation, emailConfirmationValidation)}
        />
        <Field
          label={i18next.t<string>('REGISTER_FORM:PASSWORD')}
          name="password"
          render={Input}
          type="password"
          validate={composeValidators(requiredValidation, passwordValidation)}
        />
        <Field
          label={i18next.t<string>('REGISTER_FORM:PASSWORD_CONFIRMATION')}
          name="passwordConfirmation"
          render={Input}
          type="password"
          validate={composeValidators(requiredValidation, passwordConfirmationValidation)}
        />
        <FormButtonContainer>
          <FormSubmitButton disabled={pristine || submitting} type="submit">
            {i18next.t<string>('REGISTER_FORM:SUBMIT_BUTTON')}
          </FormSubmitButton>
          <PageLink data-testid="login-link" to="/public/procedures/login">
            {i18next.t<string>('REGISTER_FORM:LOGIN')}
          </PageLink>
        </FormButtonContainer>
      </FormContent>
    )}
  />
);

export default RegisterForm;
